import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Table as SpTable } from './index.dev.js'
import { TableBody as SpTableBody } from './index.dev.js'
import { TableCell as SpTableCell } from './index.dev.js'
import { TableCheckboxCell as SpTableCheckboxCell } from './index.dev.js'
import { TableHead as SpTableHead } from './index.dev.js'
import { TableHeadCell as SpTableHeadCell } from './index.dev.js'
import { TableRow as SpTableRow } from './index.dev.js'

export const Table = dynamic<
    JSX.LibraryManagedAttributes<typeof SpTable, ComponentProps<typeof SpTable>>
>(() => import('./index.dev.js').then(({ Table }) => Table), { ssr: false });
export const TableBody = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableBody,
        ComponentProps<typeof SpTableBody>
    >
>(() => import('./index.dev.js').then(({ TableBody }) => TableBody), {
    ssr: false,
});
export const TableCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableCell,
        ComponentProps<typeof SpTableCell>
    >
>(() => import('./index.dev.js').then(({ TableCell }) => TableCell), {
    ssr: false,
});
export const TableCheckboxCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableCheckboxCell,
        ComponentProps<typeof SpTableCheckboxCell>
    >
>(
    () =>
        import('./index.dev.js').then(({ TableCheckboxCell }) => TableCheckboxCell),
    { ssr: false }
);
export const TableHead = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableHead,
        ComponentProps<typeof SpTableHead>
    >
>(() => import('./index.dev.js').then(({ TableHead }) => TableHead), {
    ssr: false,
});
export const TableHeadCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableHeadCell,
        ComponentProps<typeof SpTableHeadCell>
    >
>(() => import('./index.dev.js').then(({ TableHeadCell }) => TableHeadCell), {
    ssr: false,
});
export const TableRow = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableRow,
        ComponentProps<typeof SpTableRow>
    >
>(() => import('./index.dev.js').then(({ TableRow }) => TableRow), { ssr: false });
